import Transaction from '@/structs/transaction.js'
import { dateToInteger } from '@/parse-and-play/utils.js'

class BankTransactions {
  constructor (options) {
    this.options = options || {}
    this.rules = options.rules || []
    this.elidedAccount = options.elidedAccount || 'Assets:Unknown'
  }

  async process (input) {
    const rawTransactions = JSON.parse(input)
    const transactions = []

    for (const raw of rawTransactions) {
      // Apply categorization rules
      const categorized = this.applyRules(raw)

      // Convert to Transaction format
      const transaction = new Transaction({
        date: dateToInteger(new Date(raw.date.replace(/\//g, '-'))),
        payee: categorized.payee || raw.payee,
        amount: raw.amount,
        raw: raw,
        postings: [
          {
            account: categorized.category || 'Expenses:Uncategorized',
            amount: this.parseAmount(raw.amount),
            currency: this.parseCurrency(raw.amount)
          },
          {
            account: this.elidedAccount,
            amount: -this.parseAmount(raw.amount),
            currency: this.parseCurrency(raw.amount),
            elided: true
          }
        ]
      })

      transactions.push(transaction)
    }

    return {
      accounts: [],
      transactions,
      periodics: []
    }
  }

  applyRules (transaction) {
    const result = { payee: null, category: null }
    const str = JSON.stringify(transaction)

    for (const rule of this.rules) {
      if (!rule.pattern) continue

      try {
        const regex = new RegExp(rule.pattern, 'i')
        if (regex.test(str)) {
          if (rule.payee) result.payee = rule.payee
          if (rule.category) result.category = rule.category
          break // First match wins
        }
      } catch (e) {
        // Invalid regex, skip
      }
    }

    return result
  }

  parseAmount (amountStr) {
    // Parse "123.45 CAD" or "-123.45 CAD"
    const match = amountStr.match(/([-\d.]+)/)
    return match ? parseFloat(match[1]) : 0
  }

  parseCurrency (amountStr) {
    const match = amountStr.match(/([A-Z]{3})/)
    return match ? match[1] : 'CAD'
  }
}

export default BankTransactions
